import * as React from 'react';
import { Action, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { AppStates } from '../../../../../../';
import PageJumpToolButtons from './PageJumpToolButtons';
import IconButton from '../../common/IconButton';
import PageJumpToolDisplay from './PageJumpToolDisplay';
import * as PageAction from '../../../actions/PageAction';
import { PagesState } from '../../../reducers/pages';
import { Publication } from '../../../types/epub';

interface PageJumpToolPanelProps {
  readonly pagesState: PagesState;
  readonly publication: Publication | undefined;
  readonly dispatch: Dispatch<Action>;
}

interface PageJumpToolPanelState {
  numbers: number[];
}

const containerStyle: React.CSSProperties = {
  width: '212px',
  marginTop: '10px',
  marginBottom: '20px',
  display: 'flex',
  flexDirection: 'column',
};

const okButtonStyle: React.CSSProperties = {
  width: '88px',
  height: '40px',
  margin: '0 58px',
};

const okButtonImageStyle: React.CSSProperties = {
  width: '88px',
  height: '40px',
};

class PageJumpToolPanel extends React.PureComponent<
  PageJumpToolPanelProps,
  PageJumpToolPanelState
> {
  public constructor(props: Readonly<PageJumpToolPanelProps>) {
    super(props);

    this.state = {
      numbers: [],
    };
  }

  private addNum = (num: number) => {
    const maxLength = 12;
    // 最初の入力が0の場合、入力を無効にする
    if (this.state.numbers.length === 0 && num === 0) {
      return;
    }

    // 文字数がMaxより多い場合、入力を無効にする
    if (this.state.numbers.length >= maxLength) {
      return;
    }

    this.setState({
      numbers: [...this.state.numbers, num],
    });
  }

  private clearNum = () => {
    this.setState({
      numbers: [],
    });
  }

  private movePageAction = () => {
    const { dispatch, pagesState, publication } = this.props;

    if (publication === undefined) {
      throw new Error('Unexpected state.');
    }

    if (this.state.numbers.length === 0) {
      return;
    }

    const maxPageIndex = publication.renditions[0].linearItems.length - 1;
    const resultText = this.state.numbers.length === 0 ? '' : this.state.numbers.join('');
    const pageIndex = parseInt(resultText, 10) - 1;

    if (maxPageIndex < pageIndex) {
      // ページを超えたときの仕様が未確定のため、一旦なにもしない
      return;
    }

    PageAction.moveToPage(pagesState.activeTab, pageIndex, dispatch);

    this.setState({
      numbers: [],
    });
  }

  public render() {
    const resultText = this.state.numbers.length === 0 ? '' : this.state.numbers.join('');

    return (
      <div style={containerStyle}>
        <PageJumpToolDisplay  text={resultText}/>
        <PageJumpToolButtons onNumButtonsClick={this.addNum} onClearButtonClick={this.clearNum} />
        <IconButton imagePath="images/page-navigator/btn_ok"
          style={okButtonStyle}
          imageStyle={okButtonImageStyle}
          svgStyle={okButtonImageStyle}
          onClick={this.movePageAction}
          />
      </div>
    );
  }
}

const mapStateToProps = (appStates: AppStates) => {
  return {
    pagesState: appStates.pages,
    publication: appStates.publication,
  };
};

export default connect(mapStateToProps)(PageJumpToolPanel);
